const $ = require('jquery');
'use strict';
///*------------------------------------------
///* всплывающая форма при заказе консультации   
///*------------------------------------------
const openModalForm = (() => { 	 
   $('.open-modalf').on('click', function(e) {
    e.preventDefault();
    const dataService = $(this).attr('data-service');
  $('input#hidden-form').val(dataService);
   $('.popup-f, .overlay-f').css({'opacity':'1', 'visibility':'visible'});
   $('.popup-f .close-modal').click(function () {
	$('.popup-f, .popup2, .overlay-f').css({'opacity':'0', 'visibility':'hidden'});
	$('.popup-f > .fofm textarea').val('');
	$(':input','.fofm').not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
	});
  });
});
export default openModalForm;


// WEBPACK FOOTER //
// ./app/components/modalform_open.js